var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDuoMale(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    transform: "rotate(0 0 0)",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M5.17864 10.0204C7.74755 7.45151 11.9124 7.45153 14.4814 10.0204C17.0503 12.5894 17.0503 16.7542 14.4814 19.3232C11.9124 21.8921 7.74756 21.8921 5.17864 19.3232C2.60973 16.7542 2.60972 12.5894 5.17864 10.0204ZM13.4208 11.081C11.4377 9.09786 8.22232 9.09785 6.23918 11.081C4.25605 13.0641 4.25607 16.2795 6.23918 18.2626C8.22232 20.2458 11.4377 20.2458 13.4208 18.2626C15.404 16.2795 15.404 13.0641 13.4208 11.081Z",
    fill: "currentColor "
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9873 3.75586C19.999 3.7557 20.0107 3.75743 20.0225 3.75781C20.0543 3.75894 20.0855 3.76163 20.1162 3.7666C20.2669 3.79061 20.4122 3.85849 20.5283 3.97461C20.6824 4.12872 20.7532 4.33334 20.7451 4.53516L20.7471 9.16406C20.7472 9.57823 20.4112 9.91387 19.9971 9.91406C19.583 9.91398 19.2472 9.57814 19.2471 9.16406L19.2451 6.31738L14.9795 10.582C14.8253 10.3884 14.6607 10.1997 14.4814 10.0205C14.302 9.84103 14.1139 9.67491 13.9199 9.52051L18.1865 5.25488L15.3369 5.25391L15.2598 5.25C14.8817 5.21141 14.5869 4.89207 14.5869 4.50391C14.587 4.08975 14.9228 3.75387 15.3369 3.75391L19.9873 3.75586Z",
    fill: "currentColor "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDuoMale);
export default __webpack_public_path__ + "static/media/DuoMale.548d8a066fbab91b3d7eda989d6a90a6.svg";
export { ForwardRef as ReactComponent };